import { DataSource, Layout } from "@mcleod/components";
import { AgenciesWithPrimary } from "../../../general/src/AgenciesWithPrimary";

export abstract class AutogenLayoutCustomerUsers extends Layout {
    agenciesWithPrimary: AgenciesWithPrimary;
    sourceAgencyLink: DataSource;
    sourceCustomer: DataSource;
}
